module.exports = __webpack_public_path__ + "static/media/11.69eb5b0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/11.jpg
// module id = 272
// module chunks = 0